import React from "react";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";

interface DescriptionFieldProps {
  className?: string;
  description?: string;
};

const DescriptionField: React.FC<DescriptionFieldProps> = ({ className, description }) => {
  const { t } = useSchemaTranslation();
  if (description) {
    return <p className={className || "sui-description"}>{t(description)}</p>;
  }
  return null;
};

export default DescriptionField;
